import { Form, Formik } from 'formik';
import { FormPart } from '@modules/shared/components/FormPart';
import { Modal } from '@shared/components/modals/Modal';
import { TextInputField } from '@shared/fields/TextInputField';
import { SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper } from '@styles/CommonStyles';
import { INoteModalProps } from './interfaces';

const formConfig = [{
  width: '100%',
  name: 'note',
  label: ' ',
  component: TextInputField,
  variant: 'outlined',
  multiline: true,
  minRows: 3,
  maxRows: 5,
  inputProps: { style: { resize: 'both' } }
}];

export const NoteModal = ({ row, onClose, onSubmit, notesModalLoading, noteModalPosition }: INoteModalProps) => (
  <Modal
    open
    hideBackdrop
    title="Note"
    dialogHeight="260px"
    dialogWidth="400px"
    resetPosition={noteModalPosition}
    isSubmitting={notesModalLoading}
    onClose={onClose}
  >
    <Formik
      enableReinitialize
      initialValues={row}
      validationSchema={null}
      onSubmit={onSubmit}
    >
      <Form>
        <FormPart config={formConfig} />

        <CommonButtonWrapper>
          <SaveButton isLoading={notesModalLoading} />
        </CommonButtonWrapper>
      </Form>
    </Formik>
  </Modal>
);
